import { Component, Input } from '@angular/core';

import { CustomListComponent } from '../custom-list/custom-list.component';

@Component({
  selector: 'app-custom-sales-awarding-list',
  templateUrl: './custom-sales-awarding-list.component.html',
  styleUrls: ['./custom-sales-awarding-list.component.scss'],
})
export class CustomSalesAwardingListComponent extends CustomListComponent {
  override itemsPerPageDisplayKey = `${this.translate.instant('Items per page')}:`;
  override entriesDisplayKey = '';

  private _allSelectable = false;

  @Input()
  get allSelectable(): boolean {
    return this._allSelectable;
  }

  set allSelectable(value: boolean) {
    this._allSelectable = value;
  }

  @Input()
  override get dataProvider(): any[] {
    return super.dataProvider;
  }

  override set dataProvider(value: any[]) {
    super.dataProvider = value;

    this.allSelectable = false;
    if (value && value.length > 0 && this.itemSelectableFunction !== undefined) {
      value.forEach((item) => {
        this.allSelectable = this.allSelectable || this.itemSelectableFunction(item);
      });
    }
  }
}
